import React from 'react'
import type { IconComponent } from '../Icon'
import { Icon } from '../Icon'
import * as S from './TextButton.styled'

type Props = {
  label: string
  disabled?: boolean
  icon?: IconComponent
  size?: 'small' | 'medium' | 'large'
  testid?: string
  variant?: 'primary' | 'secondary'
  onClick?: () => void
}

const iconSizeMap: Record<NonNullable<Props['size']>, number> = {
  small: 12,
  medium: 14,
  large: 16,
}

export const TextButton = ({
  label,
  icon,
  variant = 'primary',
  size = 'medium',
  testid = 'TextButton',
  disabled,
  onClick,
}: Props) => {
  return (
    <S.Container
      type="button"
      onClick={onClick}
      data-testid={testid}
      disabled={disabled}
      $size={size}
      $variant={variant}
      as={onClick ? 'button' : 'div'}
    >
      {icon && <Icon component={icon} height={iconSizeMap[size]} />}
      {label}
    </S.Container>
  )
}
